import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ResponseData } from 'src/app/Model/Base/Response';
import { CountryModel } from 'src/app/Model/Country.model';
import { DocumentTypeModel } from 'src/app/Model/DocumentType.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RequestIdentificationModel } from 'src/app/Model/RequestIdentification.model';
import { SalesTypeModel } from 'src/app/Model/SalesType.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { ComService } from 'src/app/Services/com-service/com.service';
import { crmGeoService } from 'src/app/Services/crm-geo-service/crm-geo-service.service';
import { RequestService } from 'src/app/Services/request/request.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Flows } from 'src/app/Model/Enums/Flow.enums';

@Component({
  selector: 'app-agency-identification',
  templateUrl: './agency-identification.component.html',
  styleUrls: ['./agency-identification.component.css']
})
export class AgencyIdentificationComponent implements OnInit {
  public isMobile: boolean = false;
  @Input() request: RequestModel;
  @Input() lstStatuses: VRequestStatusProcessModel[];
  @Input() lstDocTypes: DocumentTypeModel[];
  showChangeReason: boolean;
  newRequest: RequestModel;
  identification: RequestIdentificationModel;
  hideSaveButton: boolean = false;
  allowEdit:boolean;
  extCountryBool:boolean = false;
  IsNewIataBool:boolean = false;
  public lstSaleType: SalesTypeModel[];
  options: string[] = []
  filteredOptions:Observable<string[]>;
  lstCountries: CountryModel[];
  @Output() newRequestEvent = new EventEmitter<number>();
  @Output() updateCrmEvent = new EventEmitter<boolean>();
  @ViewChild('popUp',{static: false})
  popUp: ElementRef;
  form = new FormGroup({
    name: new FormControl('',
      [Validators.required,
      Validators.maxLength(100),
      CustomValidators.emptyTextValidator(),
      this.checkGlobalName()
      ]),
    idglobalname: new FormControl('',),
    comercialName: new FormControl('',
      [Validators.required,
      Validators.maxLength(100),
      
      CustomValidators.emptyTextValidator(),]),
    businessname: new FormControl('',
      [Validators.required,
      Validators.maxLength(100),
      CustomValidators.SpacesNoRepeatedValidator(),
      
      CustomValidators.emptyTextValidator(),]),
    agencyWebSite: new FormControl('',
      [Validators.required,
      Validators.maxLength(100),
      
      CustomValidators.emptyTextValidator(),]),
    documentType: new FormControl('',
      [Validators.required
      ]),
    documentTypeName: new FormControl('',
      []),
    saleType: new FormControl('',
      [Validators.required
      ]),
    nit: new FormControl('', [
      Validators.required,
      Validators.maxLength(20),
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlySiglaValidator()]),
    nitext: new FormControl('', [
        Validators.required,
        Validators.maxLength(20),
        CustomValidators.emptyTextValidator()]),
    address: new FormControl('',
      [Validators.required,
      Validators.maxLength(200),
      CustomValidators.emptyTextValidator()]),
    areaCode: new FormControl('',
      [Validators.required,
      Validators.maxLength(5),
      CustomValidators.numbersOnlyValidator()]),
    phone: new FormControl('',
      [Validators.required,
      Validators.maxLength(30),
      CustomValidators.numbersOnlyValidator(),
      ]),
    changeReason: new FormControl('',
      [Validators.required,
        CustomValidators.emptyTextValidator()]),
  });
  get name() { return this.form.get('name'); }
  get idglobalname() { return this.form.get('idglobalname'); }
  get businessname() { return this.form.get('businessname'); }
  get agencyWebSite() { return this.form.get('agencyWebSite'); }
  get documentType() { return this.form.get('documentType'); }
  get documentTypeName() { return this.form.get('documentTypeName'); }
  get saleType() { return this.form.get('saleType'); }
  get comercialName() { return this.form.get('comercialName'); }
  get nit() { return this.form.get('nit'); }
  get nitext() { return this.form.get('nitext'); }
  get address() { return this.form.get('address'); }
  get areaCode() { return this.form.get('areaCode'); }
  get phone() { return this.form.get('phone'); }
  get changeReason() { return this.form.get('changeReason'); }
  @Output() nextEvent = new EventEmitter();
  nextStep() {
    if (this.identification == null || this.identification.Id == null)
      Swal.fire({
        title: this.translate.instant('Request.Messages.ContinueNextTitle'),
        text: this.translate.instant('Request.Messages.ContinueNext'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('Request.Label.Yes'),
        cancelButtonText:this.translate.instant('Request.Label.No')
      
      }).then((result) => {
        if (result.isConfirmed) {
          this.nextEvent.emit();
        }
      })
    else
      this.nextEvent.emit();
  }
  @Output() prevEvent = new EventEmitter();
  prevStep() {
    this.prevEvent.emit();
  }
  constructor(
    breakpointObserver: BreakpointObserver,
    private readonly requestService: RequestService,
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly crmGeoService: crmGeoService,
    private readonly dataService: ComService,
    private readonly lsService : SessionStorageService
  ) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }

  notifierSubscription: Subscription = this.dataService.componentUpdateNotifier?.subscribe(async notified => {
    // originator has notified me. refresh my data here.
    //this.ngOnInit()
    this.ngOnChanges()
    await this.loadDocumentTypesCrm(notified)
    
  });

  ngOnChanges() {
    let countryColombia = environment.request.countryColombia
    this.agencyWebSite.enable()
    this.saleType.enable() 
    this.documentType.enable() 
    this.businessname.enable()
    this.comercialName.enable();
    this.name.enable();
    this.address.enable();
    this.areaCode.enable();
    this.phone.enable();
    this.allowEdit= this.lstStatuses.some(x=>x.IdComponent==3)
   
    if (this.identification == null || (this.identification.Id == null && this.request.RequestIdentification != null && this.request.RequestIdentification.length > 0)) {
      this.newRequest = Object.assign({}, this.request);
      
      if (this.newRequest != null && this.newRequest.RequestIdentification != null && this.newRequest.RequestIdentification.length > 0) {
        
        this.identification = this.newRequest.RequestIdentification[0];
      }
      else
        this.identification = new RequestIdentificationModel();
    }
    /**Validaciones de Nit Externo */
    if(this.request.RequestLocation != undefined){
      if(this.request.RequestLocation[0].IdCountry == countryColombia){
        this.extCountryBool = false
        this.nit.enable()
        this.nitext.disable()
      
      }
      else{
        this.extCountryBool = true
        this.nit.disable()
        this.nitext.enable()
      }
    }

    if(this.request.IsNewIata){
      this.IsNewIataBool = true;
      this.businessname.disable();
      this.comercialName.disable();
      this.documentType.disable();
      this.nit.disable();
      this.nitext.disable();
    }

    if(this.request.IsUpdateCrm && this.allowEdit){
      this.name.disable();
      this.areaCode.disable();
      this.phone.disable();
      this.agencyWebSite.disable();
      this.saleType.disable(); 
    }

   
    //se envió el formulario y fue enviado a corrección
    if(this.request!=null && this.request.RequestStatus!=null && !this.allowEdit)
    {
      
      if(this.request.IsUpdateCrm != true){
        this.comercialName.disable();
        this.businessname.disable()
        this.name.disable();
        this.nit.disable();
        this.nitext.disable();
        this.address.disable();
        this.areaCode.disable();
        this.phone.disable();
        this.agencyWebSite.disable()
        this.saleType.disable() 
        this.documentType.disable()        
      }
      else if(this.request.IsUpdateCrm){

        if(this.request.UpdateCrmDone == 7 && this.request.RequestStatus == 5){
              this.comercialName.disable();
              this.businessname.disable()
              this.name.disable();
              this.nit.disable();
              this.nitext.disable();
              this.address.disable();
              this.areaCode.disable();
              this.phone.disable();
              this.agencyWebSite.disable()
              this.saleType.disable() 
              this.documentType.disable()
              this.changeReason.disable()
            }
        else{
          this.name.disable();
          this.areaCode.disable();
          this.phone.disable();
          this.agencyWebSite.disable();
          this.saleType.disable(); 
        }
        
      }
    }
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if(this.request != null && syncFlows.has(this.request.IdFlow)){
        this.comercialName.disable();
        this.businessname.disable()
        this.name.disable();
        this.nit.disable();
        this.nitext.disable();
        this.address.disable();
        this.documentType.disable();
        this.areaCode.disable();
        this.phone.disable();
        this.agencyWebSite.disable();
        this.saleType.disable(); 
    }

    if(!this.request.IsNewIata){
      this.documentType.setValue(this.identification.DocumentType)
      this.documentTypeName.disable()
    }
    else{
      this.documentTypeName.setValue(this.identification.DocumentTypeName)
      this.documentType.setValue(this.identification.DocumentType)
    }
  }

  disableOption(): boolean{
    let disabled = false;
    if(this.request!=null && this.request.RequestStatus!=null && !this.allowEdit){
      if(this.request.IsUpdateCrm != true){
        disabled = true
      }
      else if(this.request.IsUpdateCrm && this.request.UpdateCrmDone == 7 && this.request.RequestStatus == 5){
        disabled = true
      }
      else{
        disabled = false
      }
    }
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if(this.request != null && syncFlows.has(this.request.IdFlow)){
      disabled = true
    }
    return disabled
  }
  
  async ngOnInit() {
    this.loadSalesType();
    this.loadNombresGolbales();
    this.filteredOptions = this.name.valueChanges.pipe(
      startWith(''),
      map(value => value != undefined ? value.length >= 3 ? this._filter(value || '') : [] : []),
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  AfterViewInit() {
    this.ValidateAll();
  }
  async onSubmit(): Promise<void> {
    
    this.hideSaveButton = true;
    this.spinner.show();
    this.identification.IdRequest = this.request.Id;
    if(this.request.IsUpdateCrm && this.identification.DocumentTypeName == undefined){
      this.identification.DocumentTypeName = this.lstDocTypes.find(x => x.Initials = this.documentType.value).Description
    }
    if(!this.ValidateAll()){
      this.identification.ChangeReason = ""
    }
    let res: ResponseData;
    await this.requestService.postIdentification(this.identification).then(resp => {
      res = resp;
    })
    this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      let json: RequestIdentificationModel = JSON.parse(res.body.response);
      this.identification = json;
      this.newRequestEvent.emit(this.request.Id);
      if(this.request.IsUpdateCrm){
        this.updateCrmEvent.emit(false);
      }
      await Swal.fire({
        html: this.popUp.nativeElement,
        width: 300,
        showCloseButton: true,
        showConfirmButton: false,
        
      }).then(res => {
        this.hideSaveButton = false;
        this.nextStep();
      })
    }
    else {
      this.hideSaveButton = false;
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )
    }
  }

  showIdentification(): boolean {
    return this.newRequest.ConnectionType == environment.request.iataConnectionType || 
    this.newRequest.ConnectionType == environment.request.syncConnectionType
  }


  async loadSalesType() {
    let lang = this.lsService.getLSItem("language")

    await this.crmGeoService.getSalesType().then(res => {
      this.lstSaleType = res;
      this.lstSaleType.forEach(saleType => {
        if(saleType.Name == "Venta Online" && lang == "en")
          saleType.Name = "Online sale"
        if(saleType.Name == "Venta Offline" && lang == "en")
          saleType.Name = "Offline sale"
        if(saleType.Name == "Otros" && lang == "en")
          saleType.Name = "Others"

        if(saleType.Name == "Venta Online" && lang == "pt")
          saleType.Name = "Venda on-line"
        if(saleType.Name == "Venta Offline" && lang == "pt")
          saleType.Name = "Venda off-line"
        if(saleType.Name == "Otros" && lang == "pt")
          saleType.Name = "Outros"
      });
    });
  }

  async DocTypeSelected(event,evt) {
    if(event.isUserInput)
      this.identification.DocumentTypeName = evt.Description
  }

  async SaleTypeSelected(event,evt) {
    if(event.isUserInput)
      this.identification.SaleTypeName = evt.Name
  }

  async loadDocumentTypesCrm(country) {

    await this.crmGeoService.getDocumentTypesCrm(country).then(res => {
      this.lstDocTypes = res;
    });
  }

  async loadNombresGolbales() {
    this.options = []
    await this.crmGeoService.getNombresGlobales().then(res => {
      this.lstCountries = res;
      this.lstCountries.forEach(element => {
        if(this.options.find(x => x == element.Name) == undefined)
        this.options.push(element.Name)
      });
    });
    if(this.name.value != undefined){
      this.identification.IdGlobalName = this.lstCountries.find(x => x.Name == this.name.value).ModifiedBy
      this.idglobalname.setValue(this.lstCountries.find(x => x.Name == this.name.value).ModifiedBy)
    }
  }

  checkGlobalName(): ValidatorFn{
    
    return (control: AbstractControl): ValidationErrors | null => {   
      if(this.options.length > 0 && control.value != undefined){
        if (!this.options.some(x => x == control.value)) {
            return { 'notFound': 'Seleccione un nombre global válido' };
        }
      }
      return null;
  };
  }

  /**
   * selectGlobalName
   */
  public selectGlobalName(event,evt) {
    if(event.isUserInput){
      this.identification.IdGlobalName = this.lstCountries.find(x => x.Name == evt).ModifiedBy
      this.idglobalname.setValue(this.lstCountries.find(x => x.Name == evt).ModifiedBy)
    }
    
  }

  /**
   * ValidateBusinessName
   */
  public ValidateBusinessName() {
    if(this.request.IsUpdateCrm ){
      if(this.businessname.value != this.identification.BusinessNameOld){
        this.showChangeReason = true
        //this.changeReason.enable()
        return true
      }else{
        this.showChangeReason = false
        //this.changeReason.disable()
        return false
      }
    }else{
        this.showChangeReason = false
        //this.changeReason.disable()
        return false
    }
    
  }

  /**
   * ValidateDocumentType
   */
  public ValidateDocumentType():boolean {
    if(this.request.IsUpdateCrm){
        if(this.documentType.value != this.identification.DocumentTypeOld
          && this.documentType.value != undefined){
          this.showChangeReason = true
          return true
        }else{
          this.showChangeReason = false
          return false
        }
    }else{
      this.showChangeReason = false
      return false
    }
  }

  /**
   * ValidateNit
   */
  public ValidateNit() {
    if(this.request.IsUpdateCrm){
        if((this.nit.value != undefined ? this.nit.value : this.nitext.value) != this.identification.AgencyNumberOld){
          this.showChangeReason = true
          //this.changeReason.enable()
          return true
        }else{
          this.showChangeReason = false
          //this.changeReason.disable()
          return false
        }
    }else{
      this.showChangeReason = false
      //this.changeReason.disable()
      return false
    }
  }

  /**
   * ValidateBusinessName
   */
  public ValidateAll() {
    if(
        this.ValidateNit() ||
        this.ValidateDocumentType() ||
        this.ValidateBusinessName()
      ){
        if(this.request!=null && this.request.RequestStatus!=null && !this.allowEdit)
        {
          if(this.request.UpdateCrmDone == 7 && this.request.RequestStatus == 5){
            this.changeReason.disable()
            return true
          }else{
            this.changeReason.enable()
            return true
          }
        }
        else{
          this.changeReason.enable()
          return true
        }
    }
    else{
      this.changeReason.disable()
      return false
      
    }
  }

  onKeyPress(event){
    return event.charCode >= 48 && event.charCode <= 57
  }
}

export class option{
  Name: "";
  NameGlobalId
}